var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { CloudFunctions } from "../../../components/FirebaseAuth/firebase";
import { Button, Form, InputGroup } from "react-bootstrap";
import Alert from "../../../components/Alert";
// superAdmin-only: transfers ownership of every account the current owner owns to an
// existing user immediately, with no email/acceptance step. Visibility here is cosmetic
// (src/pages/auth/superAdmins.ts is a frontend convenience list); the real gate is
// ltiaasConfig.LTIAAS_SUPER_ADMINS, enforced server-side in adminTransferOwnership.
export var AdminTransferOwnership = function () {
    var _a = useState(""), fromEmail = _a[0], setFromEmail = _a[1];
    var _b = useState(""), toEmail = _b[0], setToEmail = _b[1];
    var _c = useState(false), inSubmit = _c[0], setInSubmit = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(null), result = _e[0], setResult = _e[1];
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var adminTransferOwnership, res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInSubmit(true);
                    setError(null);
                    setResult(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    adminTransferOwnership = CloudFunctions.httpsCallable('oncall');
                    return [4 /*yield*/, adminTransferOwnership({
                            name: "adminTransferOwnership",
                            data: { fromEmail: fromEmail, toEmail: toEmail }
                        })];
                case 2:
                    res = _a.sent();
                    setResult(res.data);
                    setFromEmail("");
                    setToEmail("");
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1.message);
                    return [3 /*break*/, 4];
                case 4:
                    setInSubmit(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header font-weight-bold", children: _jsx("h5", { children: "Transfer Account Ownership (Admin)" }) }), _jsxs("div", { className: "card-body", children: [_jsx("p", { className: "text-muted", children: "Transfers every account the current owner owns to an existing user immediately. No email is sent -- the new owner's email must already belong to a registered user." }), error !== null &&
                        _jsx(Alert, { type: "danger", message: error, dismissible: true, onDismiss: function () { return setError(null); } }), result !== null &&
                        _jsx(Alert, { type: "success", message: "Transferred ".concat(result.accountIds.length, " account(s).") + (result.stripeWarnings.length > 0 ? " Stripe warnings: ".concat(result.stripeWarnings.join(' | ')) : ''), dismissible: true, onDismiss: function () { return setResult(null); } }), _jsxs(InputGroup, { className: "mb-2", children: [_jsx(InputGroup.Text, { children: "Current Owner's Email" }), _jsx(Form.Control, { type: "email", disabled: inSubmit, value: fromEmail, onChange: function (e) { return setFromEmail(e.target.value); } })] }), _jsxs(InputGroup, { className: "mb-3", children: [_jsx(InputGroup.Text, { children: "New Owner's Email" }), _jsx(Form.Control, { type: "email", disabled: inSubmit, value: toEmail, onChange: function (e) { return setToEmail(e.target.value); } })] }), _jsxs(Button, { variant: "danger", disabled: inSubmit || !fromEmail || !toEmail, onClick: submit, children: [inSubmit && _jsx("i", { className: "fa fa-spinner fa-spin mr-1" }), "Transfer Ownership"] })] })] }));
};
